import React from 'react'
import './style.css'

const LogoTitle = () => {
    return (
        <h1 className="Logo--title__h1">BRESHOP</h1>
    )
}

export default LogoTitle
